import { find, flattenDeep } from 'lodash'

import { store } from 'store/reducers'

export const getReportsToProjects = (userId?: string): MData.Project[] => {
  const {
    resources: { projects }
  } = store.getState() as MStore.RootState

  if (!userId) return projects

  return projects.filter(({ projectOwners }) => {
    return !!find(projectOwners, ['_id', userId])
  })
}

export const getReportsToTeams = (userId?: string): MData.Team[] => {
  const {
    resources: { teams }
  } = store.getState() as MStore.RootState

  if (!userId) return teams

  return teams.filter(({ reportsTo }) => {
    return reportsTo.includes(userId)
  })
}

export const getReportsToPositions = (userId?: string): MData.Position[] => {
  const {
    resources: { positions }
  } = store.getState() as MStore.RootState

  if (!userId) return positions

  const reportsToProjects = getReportsToProjects(userId)
  const reportsToTeams = getReportsToTeams(userId)

  const teamsPositions = reportsToTeams.map(({ positions }) => positions)
  const projectsPositions = reportsToProjects.map(({ positions }) => positions)

  const reportsToPositionsIds = new Set(flattenDeep([...teamsPositions, ...projectsPositions]))

  return positions.filter(({ _id }) => reportsToPositionsIds.has(_id))
}
